/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */
 /**
  * This module defines dom events to semantic events mapping for reservations-related events.
  */

 define('dng-reservations-dom',['jquery', 'dng-common', 'dng-reservations'], function($, dng) {

     $(document).ready(function(){
         /**
          * Helper function to extract data from a reservation modal
          *
          * @param modal
          * @returns {Array} 
          */
         var extractReservationData = function(modal) {
            var libId = $(modal).find('select[name=libraryId]').val();
            /* Carica la manifestation di base ma se viene scelta quella proposta, sceglie lei */
            var manId = $(modal).find('input[name=bestManId]').val();
            if (manId === '0') { manId = $(modal).closestData('manid'); }
            var issueId = $(modal).closestData('issueId');
            /* Estrae eventuale nota inserita dall'utente */
            var reserveNote = $(modal).find('input[name=manifestationReserveNote]').val();
            return [manId, libId, issueId, reserveNote];
         };

         // DOM events to semantic events mapping section

         $('body').on('click', '.reserve', function(event){
             event.preventDefault();
             $(this).trigger('reserve-dialog-requested', [$(this).closestData('manid'), this]);
         });

         $('body').on('click', '.reserve-item', function(event){
             event.preventDefault();
             $(this).trigger('reserve-item-dialog-requested', [$(this).closestData('manid'), this]);
         });

          $('body').on('click', '.reserve-issue', function(event){
              event.preventDefault();
              $(this).trigger('reserve-issue-dialog-requested', [$(this).closestData('manid'), $(this).closestData('issueid'), this]);
          });

         $('body').on('click', '.reserve-extra', function(event){
             event.preventDefault();
             $(this).trigger('reserve-extra-dialog-requested', [$(this).closestData('manid'), this]);
         });
         
         $('body').on('click', '.reserve-shard', function(event){
             event.preventDefault();
             $(this).trigger('reserve-shard-dialog-requested', [$(this).closestData('manid'), this]);
         });

         $('body').on('click', '.reserve-mlol', function(event){
             event.preventDefault();
             $(this).trigger('reserve-mlol-requested', [$(this).closestData('manid')]);
         });

         $('body').on('click', '.reserve-dialog .confirm-modal', function(){
             var modal = $(this).closest('.reserve-dialog');
             $(this).trigger('reservation-requested', extractReservationData(modal));
         });

         $('body').on('click', '.reserve-item-dialog .confirm-modal', function(){
             var modal = $(this).closest('.reserve-item-dialog');
             $(this).trigger('reservation-item-requested', extractReservationData(modal));
         });

         $('body').on('click', '.reserve-extra-dialog .confirm-modal', function(){
             var modal = $(this).closest('.reserve-extra-dialog');
             $(this).trigger('reservation-extra-requested', extractReservationData(modal));
         });

         $('body').on('click', '.reserve-shard-dialog .confirm-modal', function(){
             var modal = $(this).closest('.reserve-shard-dialog');
             $(this).trigger('reservation-shard-requested', extractReservationData(modal));
         });

         //Semantic events dom-specific handlers

         $('body').on('reservation-performed reservation-item-performed reservation-extra-performed reservation-shard-performed', '.reserve-dialog .reserve-item-dialog .reserve-extra-dialog .reserve-shard-dialog', function(){
             $(this).modal('hide');
         });

         $('body').on('reservation-item-requested', '.confirm-modal', function(){
             $(this).find('.btn').button('loading');
         });

         $('body').on('reservation-extra-requested', '.confirm-modal', function(){
             $(this).find('.btn').button('loading');
         });

         $('body').on('reservation-shard-requested', '.confirm-modal', function(){
             $(this).find('.btn').button('loading');
         });

         $('body').on('reservations-updated', function() {
            $('.reservations-count').trigger('refresh');
         });
     });
 });

